export const messages = {
  en: {
    createFeeByCombo: {
      title: 'Create Fee (Create by Fee Combo)',
      chooseFeeCombo: 'Choose Fee Combo',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      startTime: 'Billing Start Time',
      endTime: 'Billing End Time',
      requiredStartTime: 'Required, please enter start time',
      requiredEndTime: 'Required, please enter end time',
      feeItemEndTime: 'Fee Item End Time',
      endTimeMustGreater: 'End time must be greater than start time',
      noFeeSelected: 'No fee combo selected',
      startTimeRequired: ' start time is required',
      endTimeRequired: ' end time is required'
    },
    chooseFeeCombo: {
      title: 'Choose Fee Combo',
      searchPlaceholder: 'Enter fee combo name',
      comboName: 'Combo Name',
      createTime: 'Create Time',
      remark: 'Remark'
    }
  },
  zh: {
    createFeeByCombo: {
      title: '创建费用（根据费用套餐创建）',
      chooseFeeCombo: '选择费用套餐',
      feeType: '费用类型',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      requiredStartTime: '必填，请填写开始时间',
      requiredEndTime: '必填，请填写结束时间',
      feeItemEndTime: '费用项结束时间',
      endTimeMustGreater: '结束时间必须大于开始时间',
      noFeeSelected: '未选中要创建的费用套餐',
      startTimeRequired: '开始时间不能为空',
      endTimeRequired: '结束时间不能为空'
    },
    chooseFeeCombo: {
      title: '选择费用套餐',
      searchPlaceholder: '输入费用套餐名称',
      comboName: '套餐名称',
      createTime: '创建时间',
      remark: '说明'
    }
  }
}